import * as React from 'react';
import { Toaster as Sonner } from 'sonner';
import Icon from '@common/components/icon';

type ToasterProps = React.ComponentProps<typeof Sonner> & {
  closeButton?: boolean;
};

const Toaster = ({ closeButton = false, ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      className="tw-toaster tw-group"
      closeButton={closeButton}
      icons={{
        success: <Icon type="check" className="tw-w-6 tw-h-6" />,
        info: <Icon type="info" className="tw-w-6 tw-h-6" />,
        warning: <Icon type="warning" className="tw-w-6 tw-h-6" />,
        error: <Icon type="warning" className="tw-w-6 tw-h-6" />,
      }}
      toastOptions={{
        classNames: {
          toast: `tw-min-h-0 !tw-px-5 !tw-py-3 tw-rounded-lg !tw-border-0 tw-max-w-md !tw-gap-3 !tw-bg-background
          !tw-text-foreground !tw-border`,
          success: '!tw-bg-green-custom !tw-text-white tw-border-0 [&>div]:!tw-text-white',
          error: '!tw-bg-destructive !tw-text-white tw-border-0 [&>div]:!tw-text-white',
          warning: '!tw-bg-orange-custom !tw-text-white tw-border-0 [&>div]:!tw-text-white',
          info: '!tw-bg-primary !tw-text-white tw-border-0 [&>div]:!tw-text-white',
          description: 'tw-opacity-90',
          actionButton: '!tw-bg-primary !tw-text-primary-foreground tw-px-3 tw-py-1 tw-rounded hover:tw-opacity-90',
          cancelButton: '!tw-bg-muted !tw-text-muted-foreground tw-px-3 tw-py-1 tw-rounded hover:tw-opacity-90',
          closeButton: 'tw-bg-transparent tw-text-current tw-p-1 hover:tw-bg-white/10 tw-rounded',
          icon: 'tw-w-6 tw-h-6',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
export { toast } from 'sonner';
